import { apiWrapper } from "@/services/api";

export const getDbsCyclePorts = async (geo, corporation) => {
  try {
    const resp = await apiWrapper(
      "GET",
      `json/geo/point?geoPoint=${geo}&cycleAllowCorporationList=HELLOCYCLING&addInformation=availability:openingTime&type=cycle&key=w7uDeWxkdbGBw9j6`,
      null,
      false,
      false,
      "Mixway"
    );
    return resp.data.ResultSet.Point[0];
  } catch (err) {
    console.log('ERROR"" getDbsCyclePorts()');
    throw err;
  }
};
